import { ThemeProvider } from "styled-components";
import { useState } from "react";
import { darkTheme, lightTheme } from './utils/Themes.js';
import Navbar from "./components/Navbar";
import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import HeroSection from "./components/HeroSection";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Experience from "./components/Experience";
import Education from "./components/Education";
import ProjectDetails from "./components/ProjectDetails";
import Blogs from "./components/Blogs";
import BlogDetails from "./components/BlogDetails";
import styled from "styled-components";
import Vlogs from "./components/Vlogs"; // Correcting the import for Vlogs
import VlogDetails from "./components/VlogDetails"; // Import VlogDetails correctly

const Body = styled.div`
  background-color: ${({ theme }) => theme.bg};
  width: 100%;
  overflow-x: hidden;
`;

const Wrapper = styled.div`
  background: linear-gradient(38.73deg, rgba(204, 0, 187, 0.15) 0%, rgba(201, 32, 184, 0) 50%), 
    linear-gradient(141.27deg, rgba(0, 70, 209, 0) 50%, rgba(0, 70, 209, 0.15) 100%);
  width: 100%;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 30% 98%, 0 100%);
`;

function App() {
  const [darkMode] = useState(true);  // You can enable toggling later
  const [openModal, setOpenModal] = useState({ state: false, project: null });
  const [openBlogModal, setOpenBlogModal] = useState({ state: false, blog: null });
  const [openVlogModal, setOpenVlogModal] = useState({ state: false, vlog: null });

  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <Router>
        <Navbar />
        <Body>
          <HeroSection/>
          <Wrapper>
            <Skills />
            <Experience />
          </Wrapper>
          <Projects openModal={openModal} setOpenModal={setOpenModal} />
          <Vlogs openVlogModal={openVlogModal} setOpenVlogModal={setOpenVlogModal}/>
          <Blogs openBlogModal={openBlogModal} setOpenBlogModal={setOpenBlogModal}/>
          <Wrapper>
            <Education />
            <Contact />
          </Wrapper>
          <Footer />
          
          {/* Modal Components */}
          {openModal.state && (
            <ProjectDetails openModal={openModal} setOpenModal={setOpenModal} />
          )}
          {openVlogModal.state && (
            <VlogDetails openVlogModal={openVlogModal} setOpenVlogModal={setOpenVlogModal}/>
          )}
          {openBlogModal.state && (
            <BlogDetails openBlogModal={openBlogModal} setOpenBlogModal={setOpenBlogModal} />
          )}
        </Body>
      </Router>
    </ThemeProvider>
  );
}

export default App;
